import React from "react";
import { Box, Card, Heading } from "@origin-digital/ods-core";
import {
  QuickActions,
  QuickActionsSkeleton,
} from "../../../../components/QuickActions";
import type { QuickAction } from "../../../../services/categories/types";

interface QuickActionsSectionProps {
  quickActions: QuickAction[];
  loading: boolean;
  horizontal?: boolean;
}

export const QuickActionsSection: React.FC<QuickActionsSectionProps> = ({
  quickActions,
  loading,
  horizontal = false,
}) => {
  if (!loading && quickActions.length === 0) {
    return null;
  }

  return (
    <Box
      data-id="quick-actions-section"
      marginX={{ xs: "medium", sm: "none" }}
      style={{ height: "100%" }}
    >
      <Card
        borderRadius="medium"
        blur="medium"
        height="full"
        backgroundColor="cardBackgroundSecondary"
      >
        <Box marginBottom="large">
          <Heading component="h2" variant="h4">
            Quick actions
          </Heading>
        </Box>
        {loading ? (
          <QuickActionsSkeleton />
        ) : (
          <QuickActions quickActions={quickActions} horizontal={horizontal} />
        )}
      </Card>
    </Box>
  );
};
